module.exports = __webpack_public_path__ + "static/media/cloverbraning.073c654c.png";